<template>
  <div ref="viewPage" class="apply-add-form">
    <h2 v-if="!hideFormName" class="text-primary" style="text-align: center">
      {{ formName }}
    </h2>

    <div class="apply-add-form__share">
      <template v-if="formId == 2 || formId == 29">
        <my-tooltip :tooltip="i18n('showLeaveHistory')">
          <b-button
            variant="primary"
            class="btn-icon mr-1"
            @click="handleShowLeaveHistory"
          >
            <feather-icon icon="ListIcon" />
          </b-button>
        </my-tooltip>
      </template>

      <my-tooltip tooltip="Print process">
        <b-button
          variant="secondary"
          class="btn-icon mr-1"
          @click="handlePrint"
        >
          <feather-icon icon="PrinterIcon" />
        </b-button>
      </my-tooltip>
      <my-tooltip tooltip="Share with other staff">
        <b-button variant="success" class="btn-icon" @click="handleShare">
          <feather-icon icon="Share2Icon" />
        </b-button>
      </my-tooltip>
    </div>

    <b-overlay
      :show="!formatData"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <my-form
        v-if="formatData"
        ref="overFormRef"
        page-key="editPage"
        :data="formatData"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <div class="apply-add-form-line" />
      <time-line :data="formatHistoryData" />
      <b-img
        v-if="processInstanceId"
        :src="
          `/api/blade-flow/process/diagram-view?processInstanceId=${processInstanceId}&processDefinitionId=&?time=${new Date().getTime()}`
        "
      />
    </b-overlay>

    <slot name="audit" />
    <process-share :visible.sync="shareModalShow" :process-id="processId" />
    <c-modal
      :visible="showLeaveHistory"
      :title="'History'"
      body-class="process-modal"
      size="xl"
      :footer="false"
      @close="showLeaveHistory = false"
      @modelConfirm="showLeaveHistory = true"
    >
      <template slot="content">
        <component
          :is="'LeaveHistoryBlock'"
          v-if="showLeaveHistory"
          :user-info="data"
        />
      </template>
    </c-modal>
  </div>
</template>

<script>
// import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import templateFormAPI from '@/api/templateForm/index'
import TimeLine from '@/components/timeLine.vue'
import { BRow, BCol, BImg, BOverlay, BButton } from 'bootstrap-vue'
import CModal from '@/components/crud/modal.vue'
import { templateFormat, formatprocessHistoryData } from '@/util/func'
import MyTooltip from '@/components/myTooltip.vue'
import ProcessShare from '@/components/processShare.vue'
import LeaveHistoryBlock from './viewPage/LeaveHistoryBlock.vue'
import { deepClone } from '@/util/util'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    TimeLine,
    BImg,
    BOverlay,
    BButton,
    MyTooltip,
    ProcessShare,
    CModal,
    LeaveHistoryBlock,
  },
  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    formId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    processInstanceId: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: undefined,
    },
    defaultColumns: {
      type: Array,
      default: undefined,
    },
    hideFormName: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        isPass: false,
      },
      loading: false,
      columns: [],
      historyData: [],
      shareModalShow: false,
      showLeaveHistory: false,
      formName: '',
    }
  },
  computed: {
    option() {
      const columns = []
      const { data } = this
      this.columns.forEach((item) => {
        const temp = item
        if (this.formId === '2' || this.formId === 2) {
          if (item.field === 'departureDate' || item.field === 'arrivalDate') {
            temp.formOption.hide = Number(data.isLeave) !== 1
          }
          if (item.field === 'leavePeriod') {
            if (this.data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
          if (item.field === 'leaveUnit') {
            if (!data.leaveUnit) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }

          if (item.field === 'leaveEndTime') {
            if (data.leaveUnit === '0.5' || data.leaveUnit === 0.5) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
        }
        if (this.formId === '29' || this.formId === 29) {
          if (item.field === 'departureDate' || item.field === 'arrivalDate') {
            temp.formOption.hide = Number(data.isLeave) !== 1
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }

          if (item.field === 'leaveEndTime') {
            if (data.leaveUnit === '0.5' || data.leaveUnit === 0.5) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
            const currentDate = moment(new Date()).format('YYYY-MM-DD')
            temp.formOption.minDate = `${currentDate} 00:00:00`
          }
          if (item.field === 'leaveUnit') {
            if (!data.leaveUnit) {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
          if (item.field === 'leavePeriod') {
            if (data.leaveUnit !== '0.5') {
              temp.formOption.hide = true
            } else {
              temp.formOption.hide = false
            }
          }
        }

        if (this.formId === 24) {
          if (item.field === 'resignation') {
            temp.disabled = true
          }
          if (item.field === 'remark') {
            if (
              data.resignation &&
              data.resignation.length &&
              data.resignation.includes('5')
            ) {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
            }
          }
          temp.disabled = true
        }

        if (this.formId === 36) {
          if (item.field === 'ot') {
            const dic = {
              0: 'Sun',
              1: 'Mon',
              2: 'Tue',
              3: 'Wed',
              4: 'Thu',
              5: 'Fri',
              6: 'Sat',
              7: 'Sun',
            }
            const arr = JSON.parse(data.ot)
            arr.forEach((e) => {
              const { startTime, endTime } = e
              if (startTime.indexOf('(') === -1) {
                e.startTime = `${startTime} (${dic[moment(startTime).day()]})`
              }
              if (endTime.indexOf('(') === -1) {
                e.endTime = `${endTime} (${dic[moment(endTime).day()]})`
              }
            })
            data.ot = JSON.stringify(arr)
          }
        }

        columns.push(temp)
      })

      const option = {
        columns,
      }
      console.log(option, 'options')
      return option
    },
    formatData() {
      const { data } = this
      return data || undefined
    },
    formatHistoryData() {
      return formatprocessHistoryData(this.historyData)
    },
  },
  watch: {
    processInstanceId: {
      handler(e) {
        if (e) {
          console.log(e, 'this.processInstanceId')
          applyAPI.history({ processInstanceId: e }).then((res) => {
            this.historyData = res.data.data
          })
        }
      },
      immediate: true,
    },
    formId: {
      handler(e) {
        if (e) {
          this.onLoad(e)
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.processId) {
      this.data = undefined
      this.id = this.processId
      if (this.formId === '39') {
        applyAPI.workerDetail({ id: this.processId }).then((res) => {
          const { data } = res.data
          this.$emit('onLoaded', data)
          this.processKey = data.processKey
          this.processInstanceId = data.processInstanceId
          this.formId = data.formId
          this.data = data.map || {}
        })
      } else {
        applyAPI.detail({ id: this.processId }).then((res) => {
          const { data } = res.data
          this.$emit('onLoaded', data)
          this.processKey = data.processKey
          this.processInstanceId = data.processInstanceId
          this.formId = data.formId
          this.formName = data.formName
          if (this.formId == 29) {
            data.map.tickets = []
            data.map.ticketIds = ''
          }
          if (this.formId == 16 && data.map.interview) {
            delete data.map.interview
          }
          this.data = data.map || {}
        })
      }
    }
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_apply.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit')
    },
    handleShowLeaveHistory() {
      this.showLeaveHistory = true
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase())
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      if (this.defaultColumns) {
        this.columns = this.defaultColumns
        return
      }
      templateFormAPI.detail({ formId }).then((res) => {
        const temp = res.data.data.records
        const tempArr = templateFormat(temp)
        const resArr = []
        tempArr.forEach((item) => {
          const params = item
          console.log(item)

          if (formId == 29) {
            if (item.field !== 'tickets') {
              params.disabled = true
              params.formOption.formEditDisabled = true
            } else {
              params.formOption.rules = 'required'
            }
            console.log(params, item.field)
          } else {
            params.disabled = false
            params.formOption.formEditDisabled = false
          }
          resArr.push(params)
        })
        this.columns = resArr
      })
    },
    handleSubmit(form) {
      const params = deepClone(form)
      params.processKey = this.processKey
      params.formId = this.id
      params.processId = this.processId
      delete params.files
      //判断是否是数组
      // if (Array.isArray(params.ticketIds)) {
      //   params.ticketIds = params.ticketIds
      //     .map((item) => item.attachId)
      //     .join(',')
      // }

      if (this.formId == 29 && Array.isArray(params.tickets)) {
        params.ticketIds = params.tickets.map((item) => item.attachId).join()
      }
      delete params.tickets

      applyAPI.edit(params).then((res) => {
        this.$emit('close')
        // this.$toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: this.$t('_default.toast.title'),
        //     icon: 'BellIcon',
        //     text: this.$t('_default.toast.text.success'),
        //     variant: 'success',
        //   },
        // })
      })
    },
    transformArrayBufferToBase64(buffer) {
      let binary = ''
      const bytes = new Uint8Array(buffer)
      for (let len = bytes.byteLength, i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    handleShare() {
      this.shareModalShow = true
    },
    handlePrint() {
      const p = this.$router.resolve({ path: '/processPrint' })
      window.open(`${p.href}?processId=${this.processId}`, '_bank')
    },
  },
}
</script>

<style lang="scss" scoped>
.apply-add-form {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
  }
  &__share {
    position: absolute;
    top: -50px;
    right: 50px;
  }
}
</style>
